import { render, staticRenderFns } from "./purchasePayment.vue?vue&type=template&id=549e5dac&"
import script from "./purchasePayment.vue?vue&type=script&lang=js&"
export * from "./purchasePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports